import { render, staticRenderFns } from "./TermsConditionsPage.vue?vue&type=template&id=4097127d&"
import script from "./TermsConditionsPage.vue?vue&type=script&lang=js&"
export * from "./TermsConditionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports